import { Button } from "primereact/button";
import { useDarkModeContext } from "../contexts";

export default function DarkModeSwitch() {
  const { darkMode, setDarkMode } = useDarkModeContext();

  return (
    <Button
      icon={darkMode ? "pi pi-sun" : "pi pi-moon"}
      rounded
      text
      severity="secondary"
      onClick={() => setDarkMode(!darkMode)}
      tooltip={darkMode ? "Light mode" : "Dark mode"}
      tooltipOptions={{ position: 'bottom' }}
    />
  );
}
